export default __webpack_public_path__ + "static/media/horse-slide2.57e91848.png";